"use strict";

module.exports = {
  'name': 'sec',
  'category': 'Trigonometry',
  'syntax': ['sec(x)'],
  'description': 'Compute the secant of x in radians. Defined as 1/cos(x)',
  'examples': ['sec(2)', '1 / cos(2)'],
  'seealso': ['cot', 'csc', 'cos']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/trigonometry/sec.js
// module id = 972
// module chunks = 0